<template>
  <div v-if="totalWeight">
    <div class="text-left text-subtitle-2 ml-2 mt-2">
      Total acumulado: {{ totalWeight }}
      <v-btn
        color="info"
        x-small
        text
        class="text-transform-none"
        @click="showModal = !showModal"
      >
        Ver detalles
      </v-btn>
    </div>
    <two-sides-modal v-model="showModal" title="Peso acumulado por material">
      <v-data-table
        :items="cartGroupedByMaterialFormatted"
        :headers="headers"
        hide-default-footer
      />
      <div class="text-right text-subtitle-2 mr-4">
        Total: {{ totalWeight }}
      </div>
    </two-sides-modal>
  </div>
</template>

<script>
  import TwoSidesModal from '@/components/modals/TwoSidesModal.vue';
  import numbersFormats from '@/mixins/numbersFormats';
  export default {
    name: 'CartWeightModal',
    components: { TwoSidesModal },

    mixins: [numbersFormats],
    props: {
      cart: {
        type: Array,
        required: true,
        validator(value) {
          return value.every(
            (item) =>
              item &&
              item.name &&
              item.materialId &&
              item.reel &&
              item.reel.KWMENG != null
          );
        },
      },
    },

    data() {
      return {
        headers: [
          { text: 'Código', value: 'materialId' },
          { text: 'Descripción', value: 'name' },
          { text: 'Número de carretes', value: 'reelCount', align: 'right' },
          { text: 'Peso', value: 'weight', align: 'right' },
        ],

        showModal: false,
      };
    },

    computed: {
      cartGroupedByMaterial() {
        return Object.values(
          this.cart.reduce((acc, item) => {
            const { materialId, name, reel } = item;

            if (!acc[materialId]) {
              acc[materialId] = {
                materialId,
                name,
                reelCount: 0,
                weight: 0,
              };
            }

            acc[materialId].reelCount += 1;
            acc[materialId].weight += Number(reel.KWMENG) || 0;

            return acc;
          }, {})
        );
      },
      cartGroupedByMaterialFormatted() {
        return this.cartGroupedByMaterial.map((item) => {
          return {
            ...item,
            materialId: this.removeLeftZeros(item.materialId),
            weight: this.formatWeight(item.weight),
          };
        });
      },
      totalWeight() {
        const weight = this.cartGroupedByMaterial.reduce(
          (sum, currentValue) => sum + parseFloat(currentValue.weight),
          0
        );

        return this.formatWeight(weight, '');
      },
    },

    methods: {
      formatWeight(weight) {
        if (!weight) return '';

        return `${this.formatNumberOptionalDecimals(weight, '')} KG`;
      },
    },
  };
</script>
